import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, query }) =>
    present(
      repository
        .getResourceProjects(resource, query)
        .then((projects) => ({ resource, query, projects }))
        .catch(() => Promise.reject({ resource, query })),
    );
}

export type { Interactor };

export { createInteractor };
